module.exports = __webpack_public_path__ + "static/media/adduser.ba636646.svg";